import { render, staticRenderFns } from "./ClaimGasUnexpectedErrorStep.vue?vue&type=template&id=480f25fc"
import script from "./ClaimGasUnexpectedErrorStep.vue?vue&type=script&lang=ts"
export * from "./ClaimGasUnexpectedErrorStep.vue?vue&type=script&lang=ts"
import style0 from "./ClaimGasUnexpectedErrorStep.vue?vue&type=style&index=0&id=480f25fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports